<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" class="text-left" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- OTP submit popup -->
    <v-row justify="center">
      <v-dialog v-model="enterOtpPopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title>
              <span>Enter OTP</span>
              <v-btn class="float-right" icon @click="closeEnterOtpPopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <v-col cols="6" sm="12" md="12">
                <div>
                  <p>OTP sent to +91{{ contact_number }}</p>
                </div>
                <v-text-field
                  label="Enter OTP"
                  variant="outlined"
                  v-model="enter_otp"
                  maxlength="4"
                  style="margin-bottom: -50px;"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="12" md="12">
                <a
                  @click="sentOTP(contact_number)"
                  :class="{ 'disabled-link': isResendDisabled }"
                  style="float:right;color:#2b81d6;"
                  >Resend
                  <span class="progressbar"
                    >in 00 : {{ formatTime(timer) }}</span
                  >
                </a>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="outlined" class="mb-3 text-none" @click="closeEnterOtpPopup"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              variant="flat"
              class="mb-3 text-none"
              @click="verifyOTP(contact_number)"
              :disabled="!enter_otp"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Header -->
    <header-component
      :headerTitle="headerText"
      :router-link="getRouterLink()"
      :router-link-text="getRouterLinkText()"
      :component-name="componentsName()"
    />
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
      :color="primary_code"
    >
    </loading>
    <!-- Add Buyer -->
    <!-- Uplpad Documents popup -->
    <v-row justify="center">
      <v-dialog v-model="upload_documents" persistent max-width="364px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title>
            <v-row class="ma-1">
              <span>Upload Documents</span>
              <v-spacer></v-spacer>
              <!-- <v-btn class="float-right" icon @click="upload_documents = false"> -->
                <v-icon @click="upload_documents = false">mdi-close</v-icon>
              </v-row>
              <!-- </v-btn> -->
            </v-card-title>
          </v-card>
          <v-card-text class="download-email">
            <v-row style="display: inline;">
              <v-autocomplete
                v-model="select_documents"
                :items="select_documents_items"
                label="Select Documents"
                variant="outlined"
                type="text"
                hide-details
                class="mb-5"
              ></v-autocomplete>
              <v-file-input
                v-model="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                @update:modelValue="changeFile"
                class="mb-5"
                variant="outlined" 
                prepend-inner-icon="mdi-paperclip" 
                prepend-icon=""
                hide-details
                label="Attach pdf/doc/jpg/txt file"
              >
              </v-file-input>
              <div v-if="fileName" style="margin: -20px 10px 0px 0px;">
                <v-chip class="ma-2" close @click:close="closeChip">
                  {{ fileName }}
                </v-chip>
              </div>
              <div class="mt-6">
                <v-menu
                  ref="menu1"
                  v-if="select_documents"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="expiry_date"
                  transition="scale-transition"
                  offset-y
                  min-width="320px"
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      variant="outlined"
                      v-model="formattedExpiryDate"
                      label="Expiry Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                    ></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout">
                    <v-date-picker :min="minDate" v-model="expiry_date" hide-header color="primary" min-width="200" no-title
                      scrollable
                      :picker-date.sync="pickerDate">
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="text" class="text-none " color="primary" @click="cancelExpiryDate">Cancel</v-btn>
                      <v-btn variant="text" class="text-none " color="primary" @click="menu1 = false">Ok</v-btn>
                    </v-card-action>
                  </v-card>
                  <!-- <v-date-picker
                    :min="minDate"
                    v-model="expiry_date"
                    no-title
                    scrollable
                    :picker-date.sync="pickerDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                    <v-btn
                      text
                      color="primary"
                      variant="flat"
                      @click="$refs.menu1.save(expiry_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker> -->
                </v-menu>

              </div>
              <div v-if="uploading">
                Uploading file ({{ uploadPercentage }}%)
                <v-progress-linear
                  :value="uploadPercentage"
                  color="blue"
                  height="10"
                ></v-progress-linear>
              </div>
              <div v-if="completed">
                <v-progress-linear
                  :value="uploadPercentage"
                  color="blue"
                  height="10"
                ></v-progress-linear>
                <p style="color:green;text-align: right;">Completed</p>
              </div>
              <v-row v-if="file_data['E-Waste']">
                <v-col
                  v-for="(file, index) in file_data['E-Waste']"
                  :key="index"
                  cols="2"
                  sm="6"
                  md="6"
                  class="p-0"
                >
                  <!-- <v-chip
                    class="mt-1"
                    close
                    @click:close="removeFile('E-Waste', index)"
                  >
                    <span v-if="file.document_name.length > 5"
                      >{{ file.document_name.slice(0, 5) }}...</span
                    >
                    <span v-else>{{ file.document_name }}</span> |
                    {{ file.expiry_date.split('-').reverse().join('-') }}
                  </v-chip> -->
                  <v-chip
                    class="mt-1"
                    close
                    @click:close="removeFile('E-Waste', index)"
                  >
                    <span v-if="file.document_name.length > 5">
                      {{ file.document_name.slice(0, 5) }}...
                    </span>
                    <span v-else>{{ file.document_name }}</span> |
                    <span>
                      {{
                        formatExpiryDate(file.expiry_date)
                      }}
                    </span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <!-- <v-btn small class="text-none" outlined large color="primary" @click="upload_documents = false">Cancel</v-btn> -->
            <v-btn
              color="primary"
              variant="flat"
              class="mb-3 text-none"
              v-if="this.confirmButton != 'FINISH'"
              @click="confirmUploadFile"
              :disabled="!file || number > 0"
              >Confirm</v-btn
            >
            <v-btn
              color="primary"
              variant="flat"
              class="mb-3 text-none"
              v-if="this.confirmButton == 'FINISH'"
              @click="clickFinish"
              >Finish</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
      <v-form ref="createForm" class="dynamic-height-form mt-4">
        <v-card-text>
          <div>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3" class="text-left">
                <span class="text-align">Primary Details *</span>
              </v-col>
              <v-col cols="2" sm="3" md="3">
                <v-text-field
                  hide-details="auto"
                  v-model="name"
                  label="Name*"
                  variant="outlined"
                  type="text"
                  :rules="nameValidation"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="">
                <v-text-field
                  v-model="organization_name"
                  label="Organization Name*"
                  variant="outlined"
                  type="text"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="">
                <v-text-field
                  v-model="email_id"
                  label="Email Id*"
                  class="text-left"
                  variant="outlined"
                  type="text"
                  :rules="emailValidation"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="4" sm="3" md="3">
                <span></span>
              </v-col>
               <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="buyer_type"
                  :items="buyer_type_items"
                  item-title="name" 
                  item-value="value" 
                  label="Buyer Type*"
                  multiple
                  clearable
                  variant="outlined"
                  class="text-left"
                  type="text"
                ></v-autocomplete>
                </v-col>
              <v-col cols="3" sm="3" md="">
                <v-text-field
                  v-model="client_vendor_code"
                  label="Client Vendor Code*"
                  variant="outlined"
                  type="text"
                  :disabled="this.$store.state.action === 'edit'"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"
                ></v-text-field>
              </v-col>
              
              <v-col cols="3" sm="3" md="3">
              <div class="d-flex">
               <v-select
                    v-model="selectedCountry"
                    :items="countryList"
                    item-title="label"
                    item-value="code"
                    variant="outlined"
                    return-object
                    :menu-props="{ location: 'bottom' }"
                    style="max-width: 120px"
                  >
                    <!-- Selected value -->
                    <template v-slot:selection="{ item }">
                      <span style="display: flex; align-items: center;">
                        <span class="flag">{{ item.raw.flag }}</span>
                        <span>{{ item.raw.code }}</span>
                      </span>
                    </template>

                    <!-- Dropdown items -->
                    <template v-slot:item="{ item }">
                      <span style="display: flex; align-items: center;">
                        <span class="flag">{{ item.raw.flag }}</span>
                        <span>{{ item.raw.name }} {{ item.raw.code }}</span>
                      </span>
                    </template>
                  </v-select>
                <v-text-field
                  class="custom-prepend-icon text-left"
                  hide-details
                  v-model="mobile_number"
                  label="Mobile Number*"
                  variant="outlined"
                  type="text"
                  style="max-height: 50px"
                  :rules="mobileNumberValidation"
                  @keyup="checkinkValid(mobile_number)"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, ' ')"
                >
                </v-text-field>
                </div>
                  <span v-if="isConfigEnabled('LIQUIDATION_REMARKETING_BUYER_OTP_VERFICATION')">
                  <div class="text-left" v-if="verified_message === 'Verified' && mobile_number.length === 10 && this.contact_number2 === mobile_number">
                    <a class="" style="color:green;">{{ verified_message }}</a>
                  </div>
                  <div class="text-left" v-else>
                    <a class="generate-style mb-5" :class="{'disabled-link': isOTP,'hide-link': isNotVerified}" @click="sentOTP(mobile_number)">Verify With OTP</a>
                  </div>
                  <div :class="{'show-link': isVerified, 'hide-link': ishideVerified }" class="text-left">
                    <a class="" style="color:green;">Verified</a>
                  </div>
                  </span>
              </v-col>
              <!-- <v-col cols="3" sm="3" md="">
                <v-text-field
                  class="custom-prepend-icon"
                  hide-details="auto"
                  v-model="whats_app_number"
                  label="WhatsApp Number"
                  outlined
                  type="text"
                  :rules="mobileNumberValidation"
                  @keyup="checkinkValid(whats_app_number)"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, ' ')"
                >
                  <template v-slot:prepend-inner>+91</template>
                </v-text-field>
                <div
                  :class="{ 'show-link': isVerified }"
                  v-if="
                    verified_whatsapp_message === 'Verified' &&
                      whats_app_number.length === 10 &&
                      this.contact_number3 === whats_app_number
                  "
                >
                  <a class="" style="color:green;">{{
                    verified_whatsapp_message
                  }}</a>
                </div>
                <div v-else class="mb-5" :class="{
                      'disabled-link': isOTP,
                      'hide-link': isNotVerified
                    }">
                  <a
                    class="generate-style"
                    @click="sentOTP(whats_app_number)"
                    >Verify With OTP</a
                  >
                </div>
                <div
                  :class="{
                    'show-link': isVerified,
                    'hide-link': ishideVerified
                  }"
                >
                  <a class="" style="color:green;">Verified</a>
                </div>
              </v-col> -->
            </v-row>            
            <v-row>
              <v-col cols="1" sm="3" md="3">
                <span class="text-align"></span>
              </v-col>
              <v-col cols="2" sm="3" md="3"> </v-col>
              <v-col cols="2" sm="3" md="3"> </v-col>
              <v-col cols="3" sm="3" md="3" class="p-0">
                <v-checkbox
                  v-model="check_mobile"
                  color="indigo"
                  label="Same as WhatsApp Number"
                  class="same-checkbox"
                  hide-details
                  @update:modelValue="populateNumber"
                ></v-checkbox>
              </v-col>
              <!-- <v-col cols="3" sm="3" md="" class="p0 mt-5"> </v-col> -->
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="4" sm="3" md="3">
                <span></span>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  class="custom-prepend-icon text-left"
                  hide-details="auto"
                  v-model="whats_app_number"
                  label="WhatsApp Number"
                  variant="outlined"
                  type="text"
                  :rules="mobileNumberValidation"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, ' ')"
                >
                  <template v-slot:prepend-inner>+91</template>
                </v-text-field>
                 <span v-if="isConfigEnabled('LIQUIDATION_REMARKETING_BUYER_OTP_VERFICATION')">
                <div
                  :class="{ 'show-link': isVerified }" class="text-left"
                  v-if="
                    verified_whatsapp_message === 'Verified' &&
                      whats_app_number.length === 10 &&
                      this.contact_number3 === whats_app_number
                  "
                >
                  <a class="" style="color:green;">{{
                    verified_whatsapp_message
                  }}</a>
                </div>
                <div v-else class="mb-5 text-left" :class="{
                      'disabled-link': isOTP,
                      'hide-link': isNotVerified
                    }">
                  <a
                    class="generate-style"
                    @click="sentOTP(whats_app_number)"
                    >Verify With OTP</a
                  >
                </div>
                <div
                  :class="{
                    'show-link': isVerified,
                    'hide-link': ishideVerified
                  }" class="text-left"
                >
                  <a class="" style="color:green;">Verified</a>
                </div>
                </span>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;" v-if="isConfigEnabled('LIQUIDATION_WASTE_FUNCTIONALITY')">
              <v-col cols="12" sm="3" md="3" class="text-left">
                <span class="text-align">Waste Details </span>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-combobox
                  v-model="waste_certified"
                  :items="waste_certified_items"
                  label="Waste Certified"
                  variant="outlined"
                  class="text-left"
                  type="text"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-combobox
                  v-model="waste_type"
                  :items="waste_type_items"
                  label="Waste Type"
                  multiple
                  clearable
                  variant="outlined"
                  type="text"
                  class="text-left"
                  @update:modelValue="getWateCertificateList()"
                  :disabled="waste_certified !== 'Yes'"
                  @change="sanitizeWasteType"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-expansion-panels readonly class="custom-control_outlined-1">
                  <v-expansion-panel variant="outlined" @click="uploadDocOpenPopup" :disabled="waste_certified !== 'Yes'">
                    <v-expansion-panel-title
                      >Waste Certification
                      <template v-slot:actions>
                        <v-icon color="primary">
                          mdi-paperclip
                        </v-icon>
                      </template>
                    </v-expansion-panel-title>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-row class="mb-2 p-3" v-if="file_data['E-Waste']">
                  <v-col
                    v-for="(file, index) in file_data['E-Waste']"
                    :key="index"
                    cols="2"
                    sm="6"
                    md="6"
                    class="p-0"
                  >
                    <!-- <v-chip
                      class="mt-1"
                      close
                      @click:close="removeFile('E-Waste', index)"
                    >
                      <span v-if="file.document_name.length > 5"
                        >{{ file.document_name.slice(0, 5) }}...</span
                      >
                      <span v-else>{{ file.document_name }}</span> |
                      {{ file.expiry_date.split('-').reverse().join('-') }}
                    </v-chip> -->
                    <v-chip
                      class="mt-1"
                      close
                      @click:close="removeFile('E-Waste', index)"
                    >
                      <span v-if="file.document_name.length > 5">
                        {{ file.document_name.slice(0, 5) }}...
                      </span>
                      <span v-else>{{ file.document_name }}</span> |
                      <span>
                        {{
                          formatExpiryDate(file.expiry_date)
                        }}
                      </span>
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="12" sm="3" md="3" class="text-left">
                <span class="text-align">Business Address </span>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <v-text-field
                  v-model="address"
                  label="Address"
                  variant="outlined"
                  type="text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;" v-if="isConfigEnabled('LIQUIDATION_REMARKETING_BUYER_DETAILED_ADDRESS')">
              <v-col cols="1" sm="3" md="3">
                <span></span>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="pin_code"
                  label="PIN Code"
                  variant="outlined"
                  class="text-left"
                  type="number"
                  :rules="pinCodeValidation"
                  @keyup="checkinkValidPicode(pin_code)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-combobox
                  v-model="state"
                  :items="state_items"
                  label="State"
                  variant="outlined"
                  type="text"
                  @update:modelValue="changeStatus(state)"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-combobox
                  v-model="city"
                  label="City"
                  :items="city_items"
                  variant="outlined"
                  type="text"
                ></v-combobox>
              </v-col>
            </v-row>

            <v-row style="margin-bottom: -25px;" v-if="hide_business_details">
              <v-col cols="1" sm="3" md="3"  class="text-left">
                <span class="text-align">Business Details</span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="5" md="5" class="text-left">
                  <v-text-field
                    v-model="gst_number"
                    class="mb-0"
                    label="GST Number"
                    maxlength="15"
                    variant="outlined"
                    type="text"
                  >
                  </v-text-field>
                  <v-chip
                    v-if="uploadedGstFile"
                    color="primary"
                    style="margin-top: -30px;"
                    variant="outlined"
                    close
                    @click:close="removeFile('gst')"
                  >
                    GST
                  </v-chip>
                </v-col>
                <v-col cols="2" sm="1" md="1">
                  <input
                    type="file"
                    ref="gstFileInput"
                    id="gstFileUpload"
                    @change="handleFileUpload($event, 'gst')"
                    style="display: none;"                    
                  />
                  <v-icon
                    color="primary"
                    class="paperclip w-100"
                    variant="outlined"
                    :disabled="!gst_number"
                    @click="triggerFileUpload('gst')"
                  >
                    mdi-paperclip
                  </v-icon>
                </v-col>

                <!-- PAN Section -->
                <v-col cols="3" sm="5" md="5" class="text-left">
                  <v-text-field
                    v-model="pan_number"
                    label="PAN Number"
                    maxlength="10"
                    variant="outlined"
                    type="text"
                  >
                  </v-text-field>
                  <v-chip
                    v-if="uploadedPanFile"
                    color="primary"
                    style="margin-top: -30px;"
                    variant="outlined"
                    close
                    @click:close="removeFile('pan')"
                  >
                    PAN
                  </v-chip>
                </v-col>
                <v-col cols="2" sm="1" md="1">
                  <input
                    type="file"
                    ref="panFileInput"
                    id="panFileUpload"
                    @change="handleFileUpload($event, 'pan')"
                    style="display: none;"
                  />
                  <v-icon
                    color="primary"
                    class="paperclip w-100"
                    variant="outlined"
                    :disabled="!pan_number"
                    @click="triggerFileUpload('pan')"
                  >
                    mdi-paperclip
                  </v-icon>
                </v-col>
              </v-row>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3" class="text-left">
                <span class="text-align">Document Details</span>
              </v-col>
              <v-col cols="2" sm="9" md="9">
               <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6" class="pl-0">
                <v-combobox
                    v-model="document_type"
                    :items="document_typ_items"
                    label="Document Type"
                    variant="outlined"
                    class="text-left"
                    hide-details                    
                  >
                  </v-combobox>
                  <div class="mt-2 d-flex flex-wrap">
                      <v-chip
                        v-for="(chip, index) in select_documents_chip"
                        :key="index"
                        color="primary"
                        variant="outlined"
                        closable
                        @click:close="removeChip(chip)"
                        class="ma-1"
                      >
                        {{ chip.document_type }} ({{ chip.document_number }})
                      </v-chip>
                    </div>
                </v-col>
                <v-col cols="2" sm="5" md="5">
                <v-text-field
                    v-model="document_number"
                    class="mb-0"
                    label="Document Number"
                    maxlength="15"
                    variant="outlined"
                    hide-details
                    type="text"
                    :disabled="!document_type"
                  >
                  </v-text-field>
                  <div class="mt-2">
                    <v-chip
                      v-for="(chip, index) in selected_documents_number"
                      :key="index"
                      color="primary"
                      outlined
                      close
                      @click:close="removeNumberChip(index)"
                      class="ma-1"
                    >
                      {{ chip }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="2" sm="1" md="1">
                <input
                    type="file"
                    :ref="'fileInput' + index"
                    id="gstFileUpload"
                    @change="handleFileUpload($event, index)"
                    style="display: none;"                    
                  />
                  <v-icon
                    color="primary"
                    class="paperclip w-100"
                    variant="outlined"
                    :disabled="!document_number"
                    @click="triggerFileUpload(index)"
                  >
                    mdi-paperclip
                  </v-icon>
                  <!-- <div class="mt-2" v-if="document_details.length">
                    <v-chip
                      color="primary"
                      outlined
                      class="ma-1"
                    >
                      {{ document_details.length }}
                    </v-chip>
                  </div> -->
                </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3" class="text-left">
                <span class="text-align">Category Preference</span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6">
                  <v-combobox
                    v-model="select_category"
                    :items="select_category_items"
                    label="Select Category"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    class="text-left"
                  >
                  </v-combobox>
                </v-col>
              </v-row>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3" class="text-left">
                <span class="text-align">Geographical Preference</span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6">
                  <v-combobox
                    v-model="select_geographical"
                    :items="select_geographical_items"
                    multiple
                    clearable
                    label="Select Location"
                    variant="outlined"
                    chips
                    ref="brandAutocomplete"
                    class="text-left"
                    prepend-inner-icon="mdi-magnify"
                  >
                  </v-combobox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <span class="text-align"></span>
                </v-col>
              </v-row>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3" class="text-left">
                <span class="text-align">Lot Value Preference</span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6">
                  <v-text-field
                    v-model="format_min_lot_value"
                    :rules="minLotValueRules"
                    label="Minimum Lot Value (₹)"
                    class="text-left"
                    variant="outlined"
                    :min="0"
                    ref="min_lot_value_input"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" sm="6" md="6">
                  <v-text-field
                    v-model="format_max_lot_value"
                    :rules="maxLotValueRules"
                    label="Maximum Lot Value (₹)"
                    class="text-left"
                    variant="outlined"
                    :min="0"
                    ref="max_lot_value_input"
                    @keyup="takeValue(format_max_lot_value)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3">
                <span class="text-align"></span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6">
                  <v-text-field
                    v-model="format_min_expo_limit"
                    :rules="minExptValueRules"
                    label="Minimum Exposure Limit (₹)"
                    class="text-left"
                    variant="outlined"
                    type="text"
                    ref="min_expo_value_input"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" sm="6" md="6">
                  <v-text-field
                    :rules="maxExptValueRules"
                    v-model="format_max_expo_limit"
                    label="Maximum Exposure Limit (₹)"
                    class="text-left"
                    ref="max_expo_value_input"
                    variant="outlined"
                    type="text"
                    @keyup="takeValueExpo(format_max_expo_limit)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="3" md="3">
                <span class="text-align"></span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6">
                  <v-text-field
                    v-model="format_monthly_turnover"
                    label="Monthly Turnover (₹)"
                    variant="outlined"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" sm="6" md="6"> </v-col>
              </v-row>
            </v-row>
            <v-row style="margin-bottom: -25px;" v-if="this.$store.state.action === 'edit'">
              <v-col cols="1" sm="3" md="3" class="text-left">
                <span class="text-align">Buyer Status</span>
              </v-col>
              <v-row style="margin:0">
                <v-col cols="2" sm="6" md="6">
                  <v-combobox
                    v-model="buyer_status"
                    :items="buyer_status_items"
                    label="Select The Status"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                  >
                  </v-combobox>
                </v-col>
              </v-row>
            </v-row>
          </div>
        </v-card-text>
      </v-form>
      <v-card-actions class="submit-actions">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" color="primary" class="text-none" @click="navigateToHome">Cancel</v-btn>
        <v-btn
          color="primary"
          variant="flat"
          class="text-none"
          v-if="this.$store.state.action === 'add'"
          @click="createNewBuyer"
          :disabled="!isSubmitButtonEnabled"
          >Submit</v-btn
        >
        <v-btn
          color="primary"
          variant="flat"
          class="text-none"
          v-if="this.$store.state.action === 'edit'"
          @click="buyerUpdaterequest"
          :disabled="
            !name ||
              !organization_name ||
              !email_id ||
              !client_vendor_code ||
              !mobile_number ||
              number > 0 ||
              !pincode_valid ||
              !valid_condt ||
              !valid_condt_expo ||
              (buyer_type && !buyer_type.length > 0) ||
              (gst_number && !uploadedGstFile) ||
              !(!pan_number || uploadedPanFile) ||
              (waste_certified === 'Yes' && waste_type == 'E-Waste' && file_data['E-Waste'].length != 5)
          "
          >Update</v-btn
        >
      </v-card-actions>
  </v-card>
</template>
<script>
import { computed } from "vue";
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import Loading from "vue-loading-overlay";
// import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      headerText: "Manage Buyers",
      alert: false,
      alert_type: "success",
      alert_message: "",
      isLoading: false,
      isOTP: false,
      isVerified: false,
      isNotVerified: true,
      ishideVerified: false,
      number: 0,
      location_details: "",
      buyer_code: "",
      name: "",
      organization_name: "",
      verified_message: "",
      verified_whatsapp_message: "",
      contact_number: "",
      contact_number2: "",
      contact_number3: "",
      email_id: "",
      client_vendor_code: "",
      mobile_number: "",
      whats_app_number: "",
      address: "",
      pin_code: "",
      state: null,
      city: null,
      gst_number: "",
      pan_number: "",
      select_category: null,
      select_category_items: ["Home Decor: Furniture", "Decor Items"],
      select_geographical_items: [],
      select_geographical: null,
      min_lot_value: "",
      max_lot_value: "",
      min_expo_limit: "",
      max_expo_limit: "",
      monthly_turnover: "",
      buyer_status_items: ["Active", "Block"],
      buyer_status: "",
      state_items: [],
      city_items: [],
      check_mobile: false,
      numbervalid: false,
      item_details: "",
      fullPage: true,
      primary_code: "#0275d8",
      enterOtpPopup: false,
      enter_otp: "",
      timer: 60,
      timerInterval: null,
      select_geographical_items: "",
      duplicate_max: "",
      duplicate_max_expo: "",
      valid_condt: false,
      valid_condt_expo: false,
      waste_certified: "No",
      waste_certified_items: ["Yes", "No"],
      waste_type: null,
      waste_type_items: [],
      upload_documents: false,
      select_documents: null,
      select_documents_items: [],
      expiry_date: null,
      menu1: false,
      uploadPercentage: 0,
      upload_file: "",
      uploading: false,
      completed: false,
      confirmButton: "CONFIRM",
      file: null,
      file_url: "",
      fileName: "",
      fileDate: "",
      file_data: [],
      uploadedGstFile: null,
      uploadedPanFile: null,
      file_data_cond: false,
      pinCodeValidation: [
        v =>
          v.length === 0 || /^[0-9]{6}$/.test(v) || "PIN code must be 6 digits"
      ],
      pincode_valid: true,
      mobileNumberValidation: [
        v => !!v || "Mobile number is required",
        v => /^[0-9]{10}$/.test(v) || "Mobile number must be 10 digits"
      ],
      nameValidation: [
        v => (v.startsWith(" ") ? "Cannot start with a space" : true)
      ],
      emailValidation: [
        v => (v.startsWith(" ") ? "Cannot start with a space" : true),
        v => !!v || "Email is required",
        v =>
          /.+@.+\..+/.test(v) ||
          "Email must be valid (e.g., example@example.com)"
      ],
      attached_file_data: [],
      gst_file: "",
      gst_file_name: "",
      pan_file: "",
      pan_file_name: "",
      minDate: null, 
      pickerDate: '',
      upload_date_length:'',
      buyer_type: null,
      buyer_type_items:[{"name":"Competitive", "value":"competitive"},{"name":"Contracted", "value":"contracted"}],
      document_type: null,
      document_typ_items: [],
      document_number: null,
      custom_config_data: null,
      select_documents_chip: [],
      selected_documents_number: [],
      document_details: [],
      index_update: -1,
      currency_global_format:'',
      time_zone_format:'',
      currency_Symbol:'',
      configurations: [],
      hide_business_details: false,
      selectedCountry: {
        name: 'India',
        code: '+91',
        iso: 'IN',
        flag: '🇮🇳'
      },
      countryList: [
        { "name": 'India', "code": '+91', "iso": 'IN', "length": 10 },
        { "name": 'United States', "code": '+1', "iso": 'US', "length": 10 },
        { "name": 'United Kingdom', "code": '+44', "iso": 'GB', "length": 10 },
        { "name": 'United Arab Emirates', "code": '+971', "iso": 'AE', "length": 9 },
        { "name": 'Uganda', "code": '+256', "iso": 'UG', "length": 9 },
        { "name": 'Ukraine', "code": '+380', "iso": 'UA', "length": 9 },
      ],
    };
  },
  components: {
    HeaderComponent,
    Loading
  },
  watch: {
    select_geographical(newValue) {
      if (newValue && newValue.length > 0) {
        this.$nextTick(() => {
          this.$refs.brandAutocomplete.internalSearch = "";
        });
      }
    },
    format_min_lot_value() {
      this.validateMaxLotValue();
    },
    format_max_lot_value() {
      this.validateMinLotValue();
    },
    format_min_expo_limit() {
      this.validateMaxExpoValue();
    },
    format_max_expo_limit() {
      this.validateMinExpoValue();
    },

  },
  mounted() {
    // Calculate the date 30 days from now
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 30);
    this.minDate = currentDate.toISOString().substr(0, 10); // Format as YYYY-MM-DD
    this.getCountryList(); 
  },
  computed: {
    isResendDisabled() {
      return this.timer > 0;
    },
    minDate() {
      const today = new Date();
      const minDate = new Date(today.setDate(today.getDate() + 30));
      return minDate.toISOString().substr(0, 10);
    },
    format_min_lot_value: {
      get() {
        return this.min_lot_value
          ? this.formatCurrency(this.min_lot_value)
          : "";
      },
      set(value) {
        const numericValue = Number(value.replace(/[^0-9.-]+/g, ""));
        this.min_lot_value = isNaN(numericValue) ? "" : numericValue;
      }
    },
    format_max_lot_value: {
      get() {
        return this.max_lot_value
          ? this.formatCurrency(this.max_lot_value)
          : "";
      },
      set(value) {
        const numericValue = Number(value.replace(/[^0-9.-]+/g, ""));
        this.max_lot_value = isNaN(numericValue) ? "" : numericValue;
      }
    },
    format_min_expo_limit: {
      get() {
        return this.min_expo_limit
          ? this.formatCurrency(this.min_expo_limit)
          : "";
      },
      set(value) {
        const numericValue = Number(value.replace(/[^0-9.-]+/g, ""));
        this.min_expo_limit = isNaN(numericValue) ? "" : numericValue;
      }
    },
    format_max_expo_limit: {
      get() {
        return this.max_expo_limit
          ? this.formatCurrency(this.max_expo_limit)
          : "";
      },
      set(value) {
        const numericValue = Number(value.replace(/[^0-9.-]+/g, ""));
        this.max_expo_limit = isNaN(numericValue) ? "" : numericValue;
      }
    },
    format_monthly_turnover: {
      get() {
        return this.monthly_turnover
          ? this.formatCurrency(this.monthly_turnover)
          : "";
      },
      set(value) {
        const numericValue = Number(value.replace(/[^0-9.-]+/g, ""));
        this.monthly_turnover = isNaN(numericValue) ? "" : numericValue;
      }
    },
    // minLotValueRules() {
    //   return [
    //     v => !v || /^\d+$/.test(this.formatNumber(v)) || 'Enter a valid number',
    //    v => !this.max_lot_value || Number(this.formatNumber(v)) < Number(this.max_lot_value) || 'Minimum lot value should be less than maximum lot value',
    //   ];
    // },
    maxLotValueRules() {
      return [
        v => {
          const isValid =
            !v || /^\d+$/.test(this.formatNumber(v)) || "Enter a valid number";
          this.valid_condt = isValid === true;
          return isValid;
        },
        v => {
          const isValid =
            !v ||
            Number(this.formatNumber(v)) > Number(this.min_lot_value) ||
            "Maximum lot value should be greater than minimum lot value";
          this.valid_condt = isValid === true;
          return isValid;
        }
      ];
    },
    minLotValueRules() {
      if (this.duplicate_max > 0) {
        return [
          v =>
            !v || /^\d+$/.test(this.formatNumber(v)) || "Enter a valid number",
          v =>
            !v ||
            Number(this.formatNumber(v)) < Number(this.max_lot_value) ||
            "Maximum lot value should be greater than minimum lot value"
        ];
      }
    },
    maxExptValueRules() {
      return [
        v => {
          const isValid =
            !v || /^\d+$/.test(this.formatNumber(v)) || "Enter a valid number";
          this.valid_condt_expo = isValid === true;
          return isValid;
        },
        v => {
          const isValid =
            !v ||
            Number(this.formatNumber(v)) > Number(this.min_expo_limit) ||
            "Maximum exposure value should be greater than minimum Exposure value";
          this.valid_condt_expo = isValid === true;
          return isValid;
        }
      ];
    },
    minExptValueRules() {
      if (this.duplicate_max_expo > 0) {
        return [
          v =>
            !v || /^\d+$/.test(this.formatNumber(v)) || "Enter a valid number",
          v =>
            !v ||
            Number(this.formatNumber(v)) < Number(this.max_expo_limit) ||
            "Miniimum exposure value should be less than maximum Exposure value"
        ];
      }
    },
    isSubmitButtonEnabled() {
      if (this.waste_certified === 'Yes') {
        return (
          this.name &&
          this.organization_name &&
          this.buyer_type &&
          this.buyer_type.length > 0 &&
          this.email_id &&
          this.client_vendor_code &&
          this.mobile_number &&
          this.numbervalid &&
          // this.verified_message === 'Verified' &&
          this.valid_condt &&
          this.valid_condt_expo &&
          this.upload_date_length === 5 &&
          (!this.gst_number || this.gst_file) &&
          (!this.pan_number || this.pan_file)
        );
      } else {
        return (
          this.name &&
          this.organization_name &&
          this.buyer_type &&
          this.buyer_type.length > 0 &&
          this.email_id &&
          this.client_vendor_code &&
          this.mobile_number &&
          this.numbervalid &&
          // this.verified_message === 'Verified' &&
          this.valid_condt &&
          this.valid_condt_expo &&
          this.waste_certified
        );
      }
    },

    formattedExpiryDate() {
      if (this.expiry_date) {
        const date = new Date(this.expiry_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
  },
  created() {
    if(!this.isConfigEnabled('LIQUIDATION_WASTE_FUNCTIONALITY'))
    this.waste_certified = "No";
  
    this.getDocumentList();
    this.fetchStates();
    if (this.$store.state.action === "edit") {
      this.isVerified = true;
      this.isNotVerified = true;
      this.isOTP = true;
      this.fetchDetailsData();
    } else {
      this.isVerified = false;
      this.isNotVerified = false;
      this.ishideVerified = true;
      this.isOTP = true;
    }
  },
  methods: {
    isConfigEnabled(constantName) {
      const config = this.$store.state.configurations.filter(item => item.constant === constantName);
      return config.length ? config[0].is_enabled : {};
    },
    validateMaxLotValue() {
      this.$refs.max_lot_value_input.validate();
    },
    validateMinLotValue() {
      this.$refs.min_lot_value_input.validate();
    },
    validateMaxExpoValue() {
      this.$refs.max_expo_value_input.validate();
    },
    validateMinExpoValue() {
      this.$refs.min_expo_value_input.validate();
    },
    takeValue(value) {
      this.duplicate_max = value.length;
    },
    takeValueExpo(value) {
      this.duplicate_max_expo = value.length;
    },
    formatCurrency(value) {
      let number = typeof value === "string" ? value.replace(/,/g, "") : value;
      return Number(number) ? Number(number).toLocaleString("en-IN") : null;
    },
    formatNumber(value) {
      return typeof value === "string"
        ? Number(value.replace(/,/g, ""))
        : value;
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    getRouterLink() {
      return { name: "ManageUser" };
    },
    componentsName() {
      return "Add Buyers";
    },
    getRouterLinkText() {
      return this.headerText;
    },
    formatExpiryDate(expiryDate) {
      if (!expiryDate) return '-'; // Handle null or undefined
      if (expiryDate instanceof Date) {
        return expiryDate.toLocaleDateString('en-GB');
      }
      if (typeof expiryDate === 'string') {
        try {
          return expiryDate.split('-').reverse().join('-');
        } catch (e) {
          console.error('Invalid date format:', expiryDate);
          return '-';
        }
      }
      return '-';
    },
    // Sent Otp
    sentOTP(number) {
      this.loading = true;
      this.isOTP = true;
      const params = {
        contact_number: number
      };
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/send_otp?`, {
          params: params
        })
        .then(response => {
          if (response.data.type === "success") {
            this.isOTP = false;
            this.contact_number = number;
            this.enterOtpPopup = true;
            this.startTimer();
            this.loading = false;
            this.getOTPDetails(number);
          } else {
            this.isOTP = false;
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.isOTP = false;
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },
    formatTime(seconds) {
      const remainingSeconds = seconds % 120;
      return `${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    },

    startTimer() {
      this.timer = 60;
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    // Get OTP Details
    getOTPDetails(number) {
      const params = {
        contact_number: number
      };
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/get_otp_details?`, {
          params: params
        })
        .then(response => {
          if (response.data) {
            this.otp_verification_details = response.data.otp_verifications;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    // Verify otp(put)
    verifyOTP(number) {
      this.$httpSecured
        .put(`/api/v1/warehouse/remarketing_buyers/verify_otp`, {
          otp: this.enter_otp,
          contact_number: number
        })
        .then(response => {
          if (response.data) {
            if (number === this.mobile_number) {
              this.contact_number2 = number;
              this.verified_message = response.data.message;
            } else if (number === this.whats_app_number) {
              this.contact_number3 = number;
              this.verified_whatsapp_message = response.data.message;
            }
            this.enter_otp = "";
            this.enterOtpPopup = false;
          } else {
            this.showAlert(response.data.type);
            this.showError(response.data.message);
          }
        })
        .catch(error => {
          if (error.response.data.message) {
            this.showAlert("error", error.response.data.message);
          } else {
            this.showAlert("error", error.response.data.error);
          }
          this.loading = false;
        });
    },
    closeEnterOtpPopup() {
      this.enter_otp = "";
      this.enterOtpPopup = false;
    },
    checkinkValidPicode(value) {
      if (value.length === 6) {
        this.pincode_valid = true;
      } else if (value.length === 0) {
        this.pincode_valid = true;
      } else {
        this.pincode_valid = false;
      }
    },
    navigateToHome() {
      this.$router.push({ name: "ManageUser" });
    },
    triggerFileUpload(index) {
      const fileInput = this.$refs['fileInput' + index];
      if (fileInput) {
        fileInput.click();
      } else {
        console.error(`File input not found for index ${index}`);
      }
    },
    handleFileUpload(event, index) {
      this.index_update++;
      const file = event.target.files[0];
      const document_type = this.document_type
      const document_number = this.document_number
      const formData = new FormData();
      formData.append("file", file);
      formData.append("attachment_file_name", document_type);
      this.$httpSecured
        .post(`/api/v1/warehouse/remarketing_buyers/upload_remarketing_buyer_documents`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          if (response.data && response.data.attachment_file) {
            const file_url = response.data.attachment_file;
            const detail = {
              document_type,
              document_number,
              document_url: file_url
            };
            if (Array.isArray(this.document_details)) {
                  if (this.document_details[index]) {
                    this.document_details.splice(index, 1, detail);
                  } else {
                    this.document_details.push(detail);
                  }
                } else {
                  this.document_details = {
                    ...this.document_details,
                    [index]: detail
                  };
                }
            this.select_documents_chip.push(this.document_details[this.index_update]);
            this.document_type = null;
            this.document_number = null;
            this.document_typ_items = this.document_typ_items.filter(
              item => item !== detail.document_type
            );
          } else {
            this.showAlert(response.data.type);
            this.showError(response.data.message);
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.messagesg);
        });
    },
    fetchStates() {
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/get_state_list`)
        .then(response => {
          if (response.data) {
            this.state_items = response.data.city_list;
            this.getGeographicalList();
            this.getEwate();
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    getGeographicalList() {
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/get_city_list`)
        .then(response => {
          if (response.data) {
            this.select_geographical_items = response.data.city_list;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    getEwate() {
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/get_waste_types`)
        .then(response => {
          if (response.data) {
            this.waste_type_items = response.data.waste_types;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    changeStatus(value) {
      this.city = "";
      this.$httpSecured
        .get(
          `/api/v1/warehouse/remarketing_buyers/get_city_list?state=${value}`
        )
        .then(response => {
          if (response.data) {
            this.city_items = response.data.city_list;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    populateNumber(isChecked) {
      if (isChecked) {
        this.whats_app_number = this.mobile_number;
        if (this.check_mobile == true && this.verified_message === "Verified") {
          this.contact_number3 = this.mobile_number;
          this.verified_whatsapp_message = "Verified";
        }
      } else {
        this.contact_number3 != this.mobile_number;
        this.verified_whatsapp_message != "Verified";
        this.ishideVerified = true;
        this.isNotVerified = false;
        this.isVerified = true;
        this.whats_app_number = "";
        this.verified_whatsapp_message = "";
      }
    },
    checkinkValid(value) {
      const country = this.selectedCountry || {};
      const expectedLength = country.length || 10;
      this.isNotVerified = false;
      this.isVerified = false;
      this.ishideVerified = true;
      this.check_mobile = false;
      if (value.length === expectedLength) {
        this.numbervalid = true;
      } else {
        this.isOTP = false;
        this.numbervalid = false;
      }
    },
    createNewBuyer() {
      this.isLoading = true;
      const categoryPreferenceArray = Array.isArray(this.select_category)
        ? this.select_category
        : [this.select_category];
      const geographicalPreferenceArray = Array.isArray(
        this.select_geographical
      )
        ? this.select_geographical
        : [this.select_geographical];
    
      this.$httpSecured
        .post("/api/v1/warehouse/remarketing_buyers/create_buyer", {
          name: this.name,
          organization_name: this.organization_name,
          buyer_type:this.buyer_type,
          email: this.email_id,
          client_vendor_code: this.client_vendor_code,
          country_code: this.selectedCountry.code,
          mobile_number: this.mobile_number,
          whats_app_number: this.whats_app_number,
          address: this.address,
          pin_code: this.pin_code,
          state: this.state,
          city: this.city,
          // gst_number: this.gst_number,
          // gst_number_document: {
          //   document_name: this.gst_file_name,
          //   document_url: this.gst_file
          // },
          // pan_number: this.pan_number,
          // pan_number_document: {
          //   document_name: this.pan_file_name,
          //   document_url: this.pan_file
          // },
          business_documents: this.document_details,
          category_preference_array: categoryPreferenceArray,
          geographical_preference_array: geographicalPreferenceArray,
          minimum_lot_value: this.formatNumber(this.min_lot_value),
          maximum_lot_value: this.formatNumber(this.max_lot_value),
          minimum_exposure_limit: this.formatNumber(this.min_expo_limit),
          maximum_exposure_limit: this.formatNumber(this.max_expo_limit),
          monthly_turnover: this.formatNumber(this.monthly_turnover),
          buyer_status: this.buyer_status,
          waste_certified: this.waste_certified,
          waste_type: this.waste_type,
          waste_certificate_hash: {
            "E-Waste": this.file_data["E-Waste"]
          }
        })
        .then(response => {
          if (response.data) {
            this.message = response.data.message;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: "success"
            });
            this.isLoading = false;
            this.navigateToHome();
            this.loading = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.message ? error.response.data.message : error.response.data.error);
          this.loading = false;
          this.isLoading = false;
        });
    },
    fetchDetailsData() {
      this.isLoading = true;
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/${this.$store.state.lotIds}`)
        .then(response => {
          if (response.data) {
            this.item_details = response.data;
            this.isLoading = false;
            this.setEditDataParams();
            if (this.mobile_number === this.whats_app_number) {
              this.check_mobile = true;
            }
          } else {
            this.showAlert("error", "No Data Found");
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.isLoading = false;
        });
    },
    setEditDataParams() {
      this.name = this.item_details.name;
      this.organization_name = this.item_details.organization_name;
      this.email_id = this.item_details.email;
      this.client_vendor_code = this.item_details.client_vendor_code;
      this.mobile_number = this.item_details.mobile_number;
      this.whats_app_number = this.item_details.whats_app_number;
      this.address = this.item_details.address;
      this.pin_code = this.item_details.pin_code;
      this.state = this.item_details.state;
      this.city = this.item_details.city;
      // this.gst_number = this.item_details.gst_number;
      // this.pan_number = this.item_details.pan_number;
      // this.uploadedGstFile = this.item_details.gst_number_document.document_url;
      // this.uploadedPanFile = this.item_details.pan_number_document.document_url;
      this.document_details = this.item_details.business_documents;
      this.select_documents_chip = this.item_details.business_documents;
        const selectedTypes = this.select_documents_chip.map(doc => doc.document_type);
          selectedTypes.forEach(type => {
            const index = this.document_typ_items.indexOf(type);
            if(index == -1)
              this.document_typ_items.push(type);
            else this.document_typ_items.splice(index, 1);
          });
      this.select_category = this.item_details.category_preference_array;
      this.select_geographical = this.item_details.geographical_preference_array;
      this.min_lot_value = this.item_details.minimum_lot_value;
      this.max_lot_value = this.item_details.maximum_lot_value;
      this.min_expo_limit = this.item_details.minimum_exposure_limit;
      this.max_expo_limit = this.item_details.maximum_exposure_limit;
      this.monthly_turnover = this.item_details.monthly_turnover;
      this.buyer_status = this.item_details.buyer_status;
      if (this.item_details.waste_certified === true) {
        this.waste_certified = "Yes";
      } else if (this.item_details.waste_certified === false) {
        this.waste_certified = "No";
      }
      this.waste_type = this.item_details.waste_type == null ? null :  [this.item_details.waste_type];
      this.file_data = this.item_details.waste_certificate_hash;
      this.gst_number_document = this.item_details.gst_number_document;
      this.pan_number_document = this.item_details.pan_number_document;
       this.buyer_type = this.item_details.buyer_types;
    },
    buyerUpdaterequest() {
      this.isLoading = true;
      const categoryPreferenceArray = Array.isArray(this.select_category)
        ? this.select_category
        : [this.select_category];
      const geographicalPreferenceArray = Array.isArray(
        this.select_geographical
      )
        ? this.select_geographical
        : [this.select_geographical];
      this.$httpSecured
        .put(
          `/api/v1/warehouse/remarketing_buyers/${this.$store.state.lotIds}`,
          {
            name: this.name,
            organization_name: this.organization_name,
            email: this.email_id,
            client_vendor_code: this.client_vendor_code,
            buyer_type:this.buyer_type,
            mobile_number: this.mobile_number,
            whats_app_number: this.whats_app_number,
            address: this.address,
            pin_code: this.pin_code,
            state: this.state,
            city: this.city,
            // gst_number: this.gst_number,
            // pan_number: this.pan_number,
            // gst_number_document: {
            //   document_name: "GST",
            //   document_url: this.gst_file
            // },
            // pan_number_document: {
            //   document_name: "PAN",
            //   document_url: this.pan_file
            // },
             business_documents: this.document_details,
            category_preference_array: categoryPreferenceArray,
            geographical_preference_array: geographicalPreferenceArray,
            minimum_lot_value: this.formatNumber(this.min_lot_value),
            maximum_lot_value: this.formatNumber(this.max_lot_value),
            minimum_exposure_limit: this.formatNumber(this.min_expo_limit),
            maximum_exposure_limit: this.formatNumber(this.max_expo_limit),
            monthly_turnover: this.formatNumber(this.monthly_turnover),
            buyer_status: this.buyer_status,
            waste_certified: this.waste_certified,
            waste_type: this.waste_type,
            waste_certificate_hash: {
              "E-Waste": this.file_data["E-Waste"]
            }
          }
        )
        .then(response => {
          if (response.data) {
            this.message = response.data.message;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: "success"
            });
            this.isLoading = false;
            this.navigateToHome();
            this.loading = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.message ? error.response.data.message : error.response.data.error);
          this.loading = false;
          this.isLoading = false;
        });
    },
    uploadDocOpenPopup() {
      this.upload_documents = true;
      this.confirmButton = "CONFIRM";
    },
    confirmUploadFile() {
      if (!this.expiry_date) {
        this.showAlert(
          "error",
          "Please select an expiry date before uploading the document."
        );
        return;
      }
      this.uploadFile("start");
      this.number++;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("attachment_file_name", this.select_documents);
      var apiUrl =
        "/api/v1/warehouse/remarketing_buyers/upload_remarketing_buyer_documents";

      this.$httpSecured
        .post(apiUrl, formData)
        .then(response => {
          this.uploadFile("success");
          this.action_name = "success_msg";
          this.message = "Successfully uploaded.";
          this.messagePopWidth = "424px";
          const fileData = {
            document_name: response.data.attachment_file_name,
            document_url: response.data.attachment_file,
            expiry_date: this.expiry_date
          };
          if (!this.file_data["E-Waste"]) {
            this.file_data["E-Waste"] = [];
          }
          this.file_data["E-Waste"].push(fileData);
          this.select_documents_items = this.select_documents_items.filter(
            item => item !== this.select_documents
          );
          this.select_documents = "";
        })
        .catch(error => {
          this.number = 0;
          this.showAlert("error", error.response.data.master_file);
        });
    },
    extractFileName(url) {
      return url.substring(url.lastIndexOf("/") + 1);
    },
    // changeFile() {
    //   if (this.file) {
    //     const fileType = this.file.type;
    //     if (fileType !== "text/csv") {
    //       this.fileError = true;
    //       this.fileErrorMessage = "Only CSV files are allowed.";
    //     } else {
    //       this.fileError = false;
    //       this.fileErrorMessage = "";
    //     }
    //   } else {
    //     this.confirmButton = "CONFIRM";
    //   }
    // },
    changeFile(event) {
      const file = event;
      const allowedFileTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/png', 'text/plain'];

      if (file && !allowedFileTypes.includes(file.type)) {
        this.fileError = true;
        this.fileErrorMessage = "Only PDF, DOC, JPG, or TXT files are allowed.";
        this.file = null;
      } else {
        this.fileError = false;
        this.fileErrorMessage = "";
      }
    },
    uploadFile(status) {
      var percentage;
      this.uploading = true;
      let reader = new FileReader();
      if (status === "start") {
        reader.onprogress = event => {
          if (event.lengthComputable) {
            percentage = Math.round((event.loaded / event.total) * 50);
            this.uploadPercentage = percentage;
          }
        };
      } else if (status === "success") {
        reader.onprogress = event => {
          if (event.lengthComputable) {
            percentage = Math.round((event.loaded / event.total) * 100);
            this.uploadPercentage = percentage;
            this.uploading = false;
            this.completed = true;
            this.cancel_button_hide = true;
          }
        };
      }
      reader.onloadend = event => {
        if (status === "success") {
          setTimeout(() => {
            this.uploading = false;
            this.completed = false;
            this.uploadPercentage = 0;
            this.number = 0;
            this.confirmButton = "FINISH";
          }, 2000);
        }
      };
      reader.readAsDataURL(this.file);
    },
    clickFinish() {
      this.file = "";
      this.select_documents = "";
      this.expiry_date = null;
      this.confirmButton = "CONFIRM";
      this.fileName = "";
      this.file_data_cond = true;
      this.upload_date_length = this.file_data['E-Waste'].length
      if (this.select_documents_items == "") {
        this.upload_documents = false;
      }
    },
    closeChip() {
      this.fileName = "";
    },
    removeFile(type, index) {
      if (type === "gst") {
        this.uploadedGstFile = null;
        this.gst_file = ''
        const fileInput = document.getElementById('gstFileUpload')
        fileInput.value = ""
      } else if (type === "pan") {
        this.uploadedPanFile = null;
        const fileInput = document.getElementById('panFileUpload')
        fileInput.value = ""
        this.pan_file = ''
      }
      const documentName = this.file_data[type][index].document_name;
      this.file_data[type].splice(index, 1);
      if(type == 'E-Waste' && this.upload_date_length)
        this.upload_date_length-= 1;
      if (!this.select_documents_items.includes(documentName)) {
        this.select_documents_items.push(documentName);
      }
      this.select_documents_items.sort();
      if (this.file_data[type].length === 0) {
        delete this.file_data[type];
      }
    },
    parseDate(dateString) {
      // "30/07/2024 03:39 PM" => "30.07.2024"
      const [datePart, timePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("/");
      return `${day}.${month}.${year}`;
    },
    sanitizeWasteType() {
      this.waste_type = this.waste_type.map(type => type.trim()).filter(type => type);
    },
    getWateCertificateList() {
      if (!this.waste_type || this.waste_type.length === 0) {
        // If it's empty, stop the function here
        return;
      }

      const cleanWasteType = this.waste_type
        .map(type => type.trim())
        .filter(type => type);

      const params = {
        waste_type: cleanWasteType.join(",")
      };
      this.$httpSecured
        .get(
          `/api/v1/warehouse/remarketing_buyers/get_waste_certificate_list`,
          { params: params }
        )
        .then(response => {
          if (response.data) {
            let uploadedDocumentNames = '';
            // if(this.file_data){
            //    uploadedDocumentNames = this.file_data["E-Waste"].map(
            //   file => file.document_name
            // );
            // }           
            this.select_documents_items = response.data.certificate_list.filter(
              doc => !uploadedDocumentNames.includes(doc)
            );
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    cancelExpiryDate(){
      this.expiry_date = null
      this.menu1 = false
    },
    changeDocumentType(value) {
      if (!this.select_documents_chip.includes(value)) {
          this.select_documents_chip.push(value);
        }
        this.document_type= "";
        this.document_typ_items = this.document_typ_items.filter(
          item => !this.select_documents_chip.includes(item)
        );        
     },
    removeChip(chip) {
        this.document_details = this.document_details.filter(item => item.document_type !== chip.document_type);
        this.select_documents_chip = this.select_documents_chip.filter(item => item.document_type !== chip.document_type);
        if (!this.document_typ_items.includes(chip.document_type)) {
          this.document_typ_items.push(chip.document_type);
        }
      },  
    addDocumentNumber() {
        const val = this.document_number.trim();
        if (!this.selected_documents_number.includes(val)) {
          this.selected_documents_number.push(val);
        }
        this.document_number = "";
      },
    removeNumberChip(index) {
        this.selected_documents_number.splice(index, 1)
      },
      getDocumentList() {
        this.$httpSecured
          .get(`/api/v1/warehouse/remarketing_buyers/get_business_document_types`)
          .then(response => {
            if (response.data) {
              this.document_typ_items = response.data.business_document_types;
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },
     getFlagEmoji(countryCode) {
        return countryCode
          .toUpperCase()
          .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt()));
      },
      getCountryList() {
        this.$httpSecured
          .get(`/api/v1/warehouse/remarketing_buyers/get_supported_country_codes`)
          .then(response => {
            if (response.data) {
              this.countryList = response.data.country_codes.map(country => ({
                ...country,
                flag: this.getFlagEmoji(country.iso)  // 👈 add flag dynamically
              }));
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network " + error);
          });
      }

  }
};
</script>
<style scoped>
.dynamic-height-form {
  height: calc(var(--vh, 1vh) * 100 - 165px);
  /* Adjust the header height accordingly */
  overflow-y: auto;
}

.generate-style {
  margin-left: 10px;
  color: #1976d2 !important;
  font-size: 10px;
  cursor: pointer;
}

.disabled-link {
  pointer-events: none;
  color: #aaa !important;
}

:deep(.custom-prepend-icon  .v-input__prepend-inner) {
  padding-right: 4px !important;
  padding-top: 3px !important;
  margin-left: 10px !important;
}

.show-link {
  display: block !important;
}

.hide-link {
  display: none !important;
}

.custom-control_outlined-1 button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}
.custom-control_outlined-1 .v-expansion-panel--disabled {
  pointer-events: none;
}

.v-expansion-panel::before {
  box-shadow: none !important;
}
.v-expansion-panel--disabled .v-expansion-panel-title .v-expansion-panel-title__overlay {
  opacity: 0 !important;
}
:deep(.v-expansion-panel .v-expansion-panel-title__overlay) {
  opacity: 0 !important;
}
:deep(.v-expansion-panel .v-expansion-panel__shadow) {
  box-shadow: none !important;
}
.paperclip {
  border: 1px solid;
  padding: 5px;
  border-radius: 3px;
  height: 55px;
}
.v-input--selection-controls{
  margin-top:20px !important;
  padding-top:4px !important;
  }
.flag {
  display: inline-block;
  width: 20px;    /* fixes spacing so all flags align */
  text-align: center;
  margin-right: 4px;
}
:deep(.same-checkbox .v-selection-control .v-label){
  margin:10px !important;
}

</style>
